"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _AppConstants = _interopRequireDefault(require("../constants/AppConstants"));

var defaultState = {
  email: ''
};

var Contact = function Contact() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _AppConstants.default.ActionTypes.STORE_CONTACT:
      if (action.payload && action.payload.contactEmail) {
        return (0, _extends2.default)({}, state, {
          email: action.payload.contactEmail
        });
      }

      return state;

    default:
      return state;
  }
};

var _default = Contact;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/reducers/Contact.js
// module id = 321
// module chunks = 0